import {JSONModel, jsonProperty} from "../json.model";
import {GroupByObject} from "../misc/reduce-helpers";

export class RegionModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") name: string;
  @jsonProperty("string") code: string;
  @jsonProperty("string") countryId: string;
}

export type RegionsByCountryModel = {[key: string]: RegionModel[]};

export function regionsByCountry(regions: RegionModel[]): RegionsByCountryModel {
  return regions
    .reduce(
      (obj, item) => obj.add(item.countryId, item),
      new GroupByObject<RegionModel>(),
    )
    .toObject();
}
